import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";
import { CylinderProgress } from "../../../Components/KPI/CylinderProgressBarCustomPvin";

const FinacialDetailsApi = async (selectedFilter) => {
  try {
    const res = await axInst.post("/pvin/financial-details", selectedFilter);
    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch financial details");
  }
};

const ApplicationDetailsApi = async (selectedFilter) => {
  try {
    const res = await axInst.post("/pvin/application-details", selectedFilter);
    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch application details");
  }
};

const SummaryDetails = () => {
  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );

  const {
    data: financialData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["financial", selectedFilter],
    queryFn: () => FinacialDetailsApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: Object.keys(selectedFilter).length > 0, // only call API if filter exists
  });

  const {
    data: applicationData,
    isFetching: isFetchingApplication,
    isError: isErrorApplication,
  } = useQuery({
    queryKey: ["application", selectedFilter],
    queryFn: () => ApplicationDetailsApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: Object.keys(selectedFilter).length > 0,
  });

  if (isFetching || isFetchingApplication)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );

  if (isError || isErrorApplication)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <p className="text-red-500">Error Occurred</p>
      </div>
    );

  return (
    <div className="md:flex block gap-3 ">
      <div className="md:w-1/2 w-full bg-white rounded-lg shadow-sm p-2 relative">
        <WaterMark />
        <h2 className="pb-1 text-base font-semibold text-[#4c4c4c] border-b border-gray-200 mb-2">
          Financier Summary
        </h2>

        {Array.isArray(financialData) && financialData.length > 0 ? (
          <div className="max-h-[200px] overflow-auto">
            {financialData.map((item, index) => (
              <div key={index} className="rounded-md p-2">
                <CylinderProgress
                  label={`${item.summary_name}`}
                  percentage={item.percentage}
                  target={100}
                  value={`${item.count}`}
                  fillColor="#22C55E"
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-600">No data available</div>
        )}
      </div>
      <div className="md:w-1/2 w-full bg-white rounded-lg shadow-sm p-2 relative">
        <WaterMark />
        <h2 className="pb-1 text-base font-semibold text-[#4c4c4c] border-b border-gray-200 mb-2">
          Application Summary
        </h2>

        {Array.isArray(applicationData) && applicationData.length > 0 ? (
          <div className="max-h-[200px] overflow-auto">
            {applicationData.map((item, index) => (
              <div key={index} className="rounded-md p-2">
                <CylinderProgress
                  label={`${item.summary_name}`}
                  percentage={item.percentage}
                  target={100}
                  value={`${item.count}`}
                  fillColor="#3B82F6"
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-600">No data available</div>
        )}
      </div>
    </div>
  );
};

export default SummaryDetails;
